import React from 'react';
import { connect } from 'react-redux';
import { utils} from '../../_helpers';
import {  transactionService , userService } from '../../_services'
import { BankInfo } from '../ProfilePage/BankInfo'
import ReactTable from "react-table";
import Carousel from 'nuka-carousel';
import QRCode from 'qrcode.react';  
import Alert from 'react-s-alert';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/flip.css';

class RedeemHWGCashPage extends React.Component
{
    constructor(props){
        super(props);

        this.state = {
            amount : '' , 
            conversion : '', 
            walletHWGCash : '' , 
            txId : '' ,
            list : [] ,
            pages : 0 , 
            list_loading : true ,
            disableSubmit : false ,
            settings : {} , 
            memberBanks : null , 
            selectedBankId : 0 , 
            selectedMemberBank : null 
        }

        this.handleWalletUSDChange = this.handleWalletUSDChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.onFetchData = this.onFetchData.bind(this);
    }

    componentDidMount(){
        
        transactionService.getCompanySettings()
        .then(response => {
 
             if(response){
                 this.setState({
                    settings : response
                 })
             }
        })
        const { authentication } = this.props;

        userService.getMemberBanks(authentication.user.id)
        .then(response => {
            if(response){
                this.setState({
                    memberBanks : response
                })
            }
        })
    }

    componentWillReceiveProps(nextprops){
        if(nextprops != this.props){
            //get wallet USD 
            const { wallet } = nextprops ; 
    
            if(wallet.userwallet && wallet.userwallet.length > 0){
                wallet.userwallet.find((obj) => { 
                    if(obj.currency === 'HWGCash') {
                        this.setState ({
                            walletHWGCash : obj.balance 
                        }) 
                    }
                })
            }
        }
    }

    onFetchData(state , instance){
        const { authentication } = this.props;

        state.page += 1;    //fix react table state started from one 
        
        transactionService.getMemberHWGCashRedeemTransactionList(state.page , state.pageSize , authentication.user.id)
        .then(response => {
            if(response){
                //update state with list 
                this.setState({
                    list : response.list , 
                    pages : response.pages , 
                    list_loading : false
                })
            }
        })
    }

    handleChange(event){

        this.setState ({
            [event.target.name] : event.target.value  //update state of corresponding input name 
        }, ()=> {
            
                //update selectedmemberbank (this callback should be for dropdown only )
                this.state.memberBanks && 
                this.state.memberBanks.map((item)=>{
                    if(this.state.selectedBankId == item.id){
                        
                        this.setState({
                            selectedMemberBank : item
                        })
                    }
                });
        })

    }

    handleMemberBankUpdate(){

    }

    handleWalletUSDChange(event){
        this.setState ({
            conversion : event.target.value , 
            [event.target.name] : event.target.value   
        })
    }

    handleSubmit(event){
        event.preventDefault();
        
        const { walletHWGCash , amount , txId , method , selectedMemberBank } = this.state ; 
        const { authentication } = this.props;

        if(method === "wallet" && walletHWGCash < amount){

            Alert.error("Insufficient HWG Cash in wallet to be redeemed for USD", {
                position: 'bottom-right' , 
                effect : 'flip'
            });

            return false ; 
        }

        let formBody = {
            amount : amount , 
            memberId : authentication.user.id, 
            txId : txId , 
            memberBank : selectedMemberBank 
        }
        this.setState({
            disableSubmit : true
        });

        transactionService.createMemberHWGCashRedemption(formBody);
    
    }

    render (){
        const { wallet } = this.props;
        const { method , amount , conversion , walletHWGCash , selectedBankId , selectedMemberBank , 
                txId , list ,list_loading , pages , settings , memberBanks } = this.state; 

        const disableSubmit = this.state.disableSubmit ? 'disabled' : '' ;  

        //define table columns 
        const columns = [
            {
                Header: 'Currency',
                accessor: 'currency'  
            }, 
            {
                Header: 'Qty / Amount',
                accessor: 'amount'  
            }, 
            {
                Header: 'Order Date',
                accessor: 'createdstr'  
            }, 
            {
                Header: 'Status',
                accessor: 'status' , 
                Cell: row => (
                    <span className={`tag is-${row.value}`}>
                       {row.value}
                    </span>
                )  
            }, 
        ]

        return (
            <section className="section m-t-xs m-b-lg">
                
                <div className="columns is-mobile border-bottom p-b-xs">
                    <div className="column is-6-desktop is-6-mobile"> </div>
                    <div className="column is-6-desktop is-6-mobile is-clearfix p-t-md">
                        <div className="columns exchangeheader">

                            <h6 className="column v-centered border-right-bold light">Wallet</h6>
                            {
                                wallet.userwallet && (
                                    Array.isArray(wallet.userwallet) && 
                                    wallet.userwallet.map((walletitem)=>{
                                        return (
                                            <div key={walletitem.currency} className="column border-right p-l-md">
                                                <span className="light-text">{walletitem.currency}</span> 
                                                <br/>
                                                <h6 className="light">{utils.addZeroes(walletitem.balance.toString())}</h6>
                                            </div>
                                        )
                                    })
                                )
                            }

                        </div>
                    </div>
                </div>

                <div className="container">
                    <div className="columns">
                        <div className="column is-6">
                            <form onSubmit={this.handleSubmit} className="default-form is-clearfix">
                                <h4>HWG Cash Redemption</h4>

                                <div className="has-instruction">
                                    1. Redemption Amount
                                </div>

                                <div className="field is-horizontal m-t-lg">
                                    <div className="field-label is-small">
                                        <label className="label">HWG Cash Amount</label>
                                    </div>
                                    <div className="field-body">         
                                        <div className="columns">
                                            <div className="column is-12">                               
                                                <input className="input is-small" onChange={this.handleChange} name="amount" value={amount} type="text" placeholder="Input amount to redeem"
                                                    required
                                                /> 
                                            </div>
                                            <div className="column is-4">                               
                                                <strong> : {amount} USD </strong>
                                            </div>
                                        </div>    
                                    </div>
                                </div>

                                <div className="has-instruction">
                                    2. Select Your Wire Information to initiate USD transfer 
                                </div>

                                <div className="field is-horizontal m-t-lg">
                                    <div className="field-body">  
                                        <div className="select is-fullwidth">
                                            {
                                                memberBanks ? (
                                                    
                                                    <select value={selectedBankId} name="selectedBankId" onChange={this.handleChange}>
                                                        <option>Select Your Bank</option>                                     
                                                        {
                                                            memberBanks.length > 0  && 
                                                            memberBanks.map((item)=>{
                                                                return (
                                                                    <option value={item.id}>{item.benefBankName}</option>
                                                                )
                                                            })   
                                                        }
                                                    </select>
                                                ) 
                                                :(
                                                    <div>No Wire Information , please <a href='/account/profile' target="_blank">Update here</a></div>
                                                )
                                            }
                                        </div>     
                                    </div>
                                    
                                </div>
                                {
                                    selectedMemberBank && 
                                    <BankInfo memberBank = {selectedMemberBank} handleMemberBankUpdate={this.handleMemberBankUpdate} iteration="1" disableForm={true}/> 
                                }

                                
                                <div className="has-instruction">
                                    3. HWG Cash Redemption Wallet Address (HWGG Capital P.L.C)
                                </div>

                                {
                                    settings && 
                                    <div className='form-info m-b-md'>
                                    {
                                        settings.length > 0 && 
                                        <React.Fragment>
                                            
                                            <div className="field is-horizontal">
                                                <div className="field-label is-small">
                                                    <label className="label">Wallet Address</label>
                                                </div>
                                                <div className="field-body">
                                                {
                                                    settings.find((obj) => { 
                                                        return obj.lookupName === 'HWGCash_ADDRESS'
                                                    }).lookupValue
                                                }
                                                </div>
                                            </div>
                                            <div className="field is-horizontal">
                                                <div className="field-label is-small">
                                                    <label className="label">Wallet QR Code</label>
                                                </div>
                                                <div className="field-body">
                                                    <QRCode value={
                                                        
                                                        settings.find((obj) => { 
                                                            return obj.lookupName === 'HWGCash_ADDRESS'
                                                        }).lookupValue
                                                    } />
                                                </div>
                                            </div>
                                        </React.Fragment>
                                    }
                                    </div>
                                }
                                
                                <div className="has-instruction">
                                    4. Provide us transaction ID after sending HWG Cash to our Address
                                </div>

                                <div className="field is-horizontal">
                                    <div className="field-label is-small ">
                                        <label className="label">Transaction ID</label>
                                    </div>
                                    <div className="field-body">
                                        <input className="input is-small" value={txId} name="txId" onChange={this.handleChange} type="text" placeholder={`HWG Cash Transaction Reference`} 
                                            required
                                        />
                                    </div>
                                </div>
                                
                                
                                <div className="control m-t-lg is-pulled-right">
                                    <input type="submit" disabled={disableSubmit} className="button button-submit" value="Redeem HWG Cash"/>
                                </div>
                            </form>
                        </div>

                        
                        <div className="column is-6">
                            <h4>Redemption Orders</h4>
                            
                            <div className=" m-t-md">
                                <ReactTable
                                    manual
                                    data={list}
                                    pages={pages}
                                    loading={list_loading}
                                    columns={columns}
                                    defaultPageSize = {5} 
                                    onFetchData = {this.onFetchData}
                                    className="-striped -highlight"
                                    NoDataComponent = { ()=> { return []} }
                                />
                            </div>
                        </div>
                        
                    </div>
                </div>
            </section>
        )
    }
}

function mapStateToProps(state) {
    const { authentication , wallet } = state;

    return {
        authentication , wallet
    };
}

const connectedPage = connect(mapStateToProps)(RedeemHWGCashPage);
export { connectedPage as RedeemHWGCashPage }; 


// WEBPACK FOOTER //
// ./src/Views/HWGCashPage/RedeemHWGCashPage.jsx